import React from 'react';
import styles from './StatusIndicator.module.scss';

interface StatusIndicatorProps {
  status: string;
}

const StatusIndicator: React.FC<StatusIndicatorProps> = ({ status }) => {
  const parsedStatus = status.toLowerCase().replace(/\s+/g, '');

  let statusClassName;
  switch (parsedStatus) {
    case 'liberado':
    case 'tránsito':
      statusClassName = styles.green;
      break;
    case 'vacio':
      statusClassName = styles.grey;
      break;
    case 'asignado':
      statusClassName = styles.lightBlue;
      break;
    case 'export':
      statusClassName = styles.darkBlue;
      break;
    case 'import':
    case 'noliberado':
      statusClassName = styles.yellow;
      break;
    default:
      statusClassName = styles.defaultColor;
  }

  return (
    <div className={styles.statusWrapper}>
      <span className={`${styles.statusCircle} ${statusClassName}`} />
      {status}
    </div>
  );
};

export default StatusIndicator;
